// Messages on a ticket (TicketMessages.jsx), 2026-10-27 — Young's follow-up questions inside the ticket.
const en = {
  title: 'Messages',
  sub: 'Ask the responsible person here — the question and the answer stay in this ticket',
  empty: 'No messages yet.',
  placeholder: 'Ask a follow-up question or reply… (Ctrl+Enter to send)',
  send: 'Send',
  attach: 'Attach',
  removeFile: 'Remove the file',
  team: 'Receiving team',
  delete: 'Delete',
  deleteConfirm: 'Delete this message? It cannot be undone.',
  deleteFailed: 'Could not delete the message.',
  sendFailed: 'Could not send the message.',
  tooBig: 'That file is {{mb}} MB; the limit is 10 MB.',
  needName: 'Write your name first, so the requester knows who answered.',
  yourName: 'Your name',
  yourNamePh: 'Who is answering?',
  hint: 'Sending emails the responsible person and the people on this ticket. Works on closed tickets too.',
  mailed: 'Sent. Emailed to: {{to}}',
  savedNoMail: 'Saved in the ticket. No email was sent.',
};
const ko = {
  title: '메시지',
  sub: '담당자에게 여기서 질문하세요 — 질문과 답변이 이 티켓에 함께 남습니다',
  empty: '아직 메시지가 없습니다.',
  placeholder: '추가 질문이나 답변을 입력하세요… (Ctrl+Enter 전송)',
  send: '보내기',
  attach: '파일 첨부',
  removeFile: '파일 제거',
  team: '수신 팀',
  delete: '삭제',
  deleteConfirm: '이 메시지를 삭제하시겠습니까? 되돌릴 수 없습니다.',
  deleteFailed: '메시지를 삭제하지 못했습니다.',
  sendFailed: '메시지를 보내지 못했습니다.',
  tooBig: '파일 크기가 {{mb}} MB입니다. 최대 10 MB까지 가능합니다.',
  needName: '요청자가 누가 답했는지 알 수 있도록 이름을 먼저 입력하세요.',
  yourName: '이름',
  yourNamePh: '답변하는 사람',
  hint: '보내면 담당자와 이 티켓 관련자에게 메일이 갑니다. 종료된 티켓에서도 가능합니다.',
  mailed: '전송 완료. 메일 수신: {{to}}',
  savedNoMail: '티켓에 저장했습니다. 메일은 발송되지 않았습니다.',
};
const vi = {
  title: 'Tin nhắn',
  sub: 'Hỏi người phụ trách ngay tại đây — câu hỏi và câu trả lời được lưu trong ticket này',
  empty: 'Chưa có tin nhắn.',
  placeholder: 'Hỏi thêm hoặc trả lời… (Ctrl+Enter để gửi)',
  send: 'Gửi',
  attach: 'Đính kèm',
  removeFile: 'Bỏ file',
  team: 'Bên nhận ticket',
  delete: 'Xoá',
  deleteConfirm: 'Xoá tin nhắn này? Không hoàn tác được.',
  deleteFailed: 'Không xoá được tin nhắn.',
  sendFailed: 'Không gửi được tin nhắn.',
  tooBig: 'File nặng {{mb}} MB; tối đa 10 MB.',
  needName: 'Nhập tên trước, để người yêu cầu biết ai đã trả lời.',
  yourName: 'Tên của bạn',
  yourNamePh: 'Ai đang trả lời?',
  hint: 'Gửi xong sẽ email cho người phụ trách và những người liên quan ticket. Dùng được cả khi ticket đã đóng.',
  mailed: 'Đã gửi. Email tới: {{to}}',
  savedNoMail: 'Đã lưu vào ticket. Chưa gửi email nào.',
};
const zh = {
  title: '留言',
  sub: '在这里向负责人提问——问题和回复都保留在此工单中',
  empty: '还没有留言。',
  placeholder: '追问或回复…（Ctrl+Enter 发送）',
  send: '发送',
  attach: '附件',
  removeFile: '移除文件',
  team: '接收团队',
  delete: '删除',
  deleteConfirm: '删除这条留言？无法撤销。',
  deleteFailed: '无法删除留言。',
  sendFailed: '无法发送留言。',
  tooBig: '文件大小为 {{mb}} MB，上限为 10 MB。',
  needName: '请先填写姓名，让申请人知道是谁回复的。',
  yourName: '您的姓名',
  yourNamePh: '谁在回复？',
  hint: '发送后会邮件通知负责人及此工单相关人员。已关闭的工单也可以。',
  mailed: '已发送。邮件发送至：{{to}}',
  savedNoMail: '已保存到工单，未发送邮件。',
};
const dictionary = { ns: 'xTicketMsg', en, ko, vi, zh };
export default dictionary;
